import { render, staticRenderFns } from "./ProductItemInventory.vue?vue&type=template&id=5f14eca6&"
import script from "./ProductItemInventory.vue?vue&type=script&lang=js&"
export * from "./ProductItemInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports